import { defineComponent, createElementBlock, openBlock, createElementVNode, Fragment, renderList, normalizeClass, createVNode, withCtx, createBlock, createCommentVNode, toDisplayString, createTextVNode } from 'vue';
import _sfc_main$4 from './basler-components.es70.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es112.js';
/* empty css                        */
import _sfc_main$1 from './basler-components.es133.js';

const _hoisted_1 = { class: "nav-action-bar" };
const _hoisted_2 = { class: "nav-action-bar__list" };
const _hoisted_3 = { class: "visually-hidden" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NavActionBar",
  props: {
    items: {}
  },
  emits: ["link-hover"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", _hoisted_1, [
        createElementVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
            return openBlock(), createElementBlock("li", {
              key: `${item.title}-${index}`,
              class: normalizeClass(["nav-action-bar__list-item", `nav-action-bar__list-item--${item.type}`])
            }, [
              createVNode(_sfc_main$1, {
                class: normalizeClass(["nav-action-bar__element", { "is-active": item.isActive }]),
                uri: item.link.uri,
                rel: item.link.rel,
                target: item.link.target,
                onMouseenter: ($event) => emit("link-hover", item.type, true, $event),
                onMouseleave: ($event) => emit("link-hover", item.type, false, $event)
              }, {
                default: withCtx(() => [
                  createElementVNode("span", _hoisted_3, toDisplayString(item.title), 1),
                  item.iconName ? (openBlock(), createBlock(_sfc_main$2, {
                    key: 0,
                    name: item.iconName,
                    size: "large",
                    "aria-hidden": "true"
                  }, null, 8, ["name"])) : createCommentVNode("", true),
                  item.userInitials ? (openBlock(), createBlock(_sfc_main$3, {
                    key: 1,
                    initials: item.userInitials,
                    size: 40,
                    "aria-hidden": "true"
                  }, null, 8, ["initials"])) : createCommentVNode("", true),
                  item.badgeNumber ? (openBlock(), createBlock(_sfc_main$4, {
                    key: 2,
                    "is-round": true,
                    size: "xsmall",
                    class: "nav-action-bar__badge"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(item.badgeNumber), 1)
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "uri", "rel", "target", "onMouseenter", "onMouseleave"])
            ], 2);
          }), 128))
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
